import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'motion/react';
import ScrollArrow from './ScrollArrow';

const baseStyle = {
  height: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  scrollSnapAlign: 'start',
  // Center content within the safe area (matching the safe-area-inset arrows),
  // not the full viewport that viewport-fit=cover exposes behind the phone UI.
  boxSizing: 'border-box',
  paddingTop: 'env(safe-area-inset-top, 0px)',
  paddingBottom: 'env(safe-area-inset-bottom, 0px)',
};

function SectionLayout({ children, sectionRef, onScrollUp, onScrollDown, arrowsVisible = true, style, ...motionProps }) {
  const localRef = useRef(null);

  // Attach both our internal ref (for the scroll-linked fade) and whatever ref
  // the caller passed (object or callback).
  const setRef = (el) => {
    localRef.current = el;
    if (typeof sectionRef === 'function') sectionRef(el);
    else if (sectionRef) sectionRef.current = el;
  };

  // Fade the section in as it enters and out as it leaves. A narrow peak around
  // the centered (snapped) position means opacity drops off fast with even a
  // little scroll, so transitions read as a strong cross-fade.
  const { scrollYProgress } = useScroll({ target: localRef, offset: ['start end', 'end start'] });
  const scrollOpacity = useTransform(scrollYProgress, [0.1, 0.42, 0.58, 0.9], [0, 1, 1, 0]);

  return (
    <motion.div
      ref={setRef}
      data-snap
      {...motionProps}
      style={{ ...baseStyle, opacity: scrollOpacity, ...style }}
    >
      {onScrollUp && <ScrollArrow direction="up" position="top" visible={arrowsVisible} onClick={onScrollUp} />}
      {children}
      {onScrollDown && <ScrollArrow direction="down" position="bottom" visible={arrowsVisible} onClick={onScrollDown} />}
    </motion.div>
  );
}

export default SectionLayout;
